import * as React from 'react';

import BaseClickable from 'components/ui/BaseClickable';
import { ChevronLeft24Icon } from 'components/ui/icons/ChevronLeft24Icon';
import { callNative } from 'utils/nativeBridge';

import s from './MobileBackButton.module.scss';

const MobileBackButton: React.FC = () => {
  const handleBack = React.useCallback(() => {
    callNative('noHistory');
  }, []);

  return (
    <BaseClickable className={s.button} onClick={handleBack} aria-label="Назад" withHover>
      <ChevronLeft24Icon size={24} className={s.button__icon} />
    </BaseClickable>
  );
};

export default React.memo(MobileBackButton);
